import jwtDecode from 'jwt-decode';
import { API } from '../../../apis/api';
import { buildErrorMessage } from '../../../apis/calls';
import { API_RESOURCE_URLS } from '../../../constants';
import { logoutAndClearData } from '../../../utils/utils';


import {
  CLEAR_AUTH_DATA,
  LOAD_AUTH_DATA,
  SET_AUTH_TOKEN,
  SET_KEYCLOAK_INSTANCE,
  SET_DJANGO_AUTH_DATA,
} from './actionTypes';

/*
 * load user profile from required backend
 * eg (from production-planning):
 * ```
 * {
 *  const response = await API.get(API_RESOURCE_URLS.USER_PROFILE);
 *  return response.data;
 * }
 * ```
 */
export const getUserProfile = async () => ({});

/*
 * load user auth policies from required backend for specified resources and type of operations
 * eg (from production-planning):
 * ```
 * {
 *  try {
 *  const response = await API.get(API_RESOURCE_URLS.AUTH_BULK_RESOURCE, {
 *    params: {
 *       resourceGroup: 'production-planning',
 *       operation: Object.values(USER_OPERATIONS),
 *     },
 *   });
 *   return response.data;
 * } catch (error) {
 *   console.log('failed to load auth policy', error);
 *   return [];
 *  }
 * }
 * ```
 */
// eslint-disable-next-line
const loadAuthPolicies = async () => {
  try {
    const response = await API.get(API_RESOURCE_URLS.AUTH_ALLOWED_RESOURCE, {
      params: {
        resourceGroup: 'application-access',
        operation: 'access-application',
      },
    });
    return response.data;
  } catch (error) {
    console.error(buildErrorMessage(error));
    return [];
  }
};

const logoutUser = () => (dispatch, getState) => {
  const { keycloak } = getState().auth;
  return logoutAndClearData(keycloak)
    .then(() => dispatch({ type: CLEAR_AUTH_DATA }))
    .then(() => {
      window.location.href = '/';
    });
};

const setKeycloakInstance = keycloak => ({
  type: SET_KEYCLOAK_INSTANCE,
  instance: keycloak,
});

const generateUser = async token => {
  try {
    const { name, email, sub: userId } = jwtDecode(token);
    const userProfile = await getUserProfile();
    return { name, email, userId, ...userProfile, isLoaded: true };
  } catch (err) {
    console.log('failed to load user profile, err:', err);
    return null;
  }
};

const loadAuthData = (token, authenticated) => async dispatch => {
  const user = await generateUser(token);
  // const authPolicies = await loadAuthPolicies(token);
  localStorage.setItem("token",token);
  console.log("token -----------------> ", token)
  return dispatch({
    type: LOAD_AUTH_DATA,
    payload: {
      user,
      isAuthenticated: authenticated,
      // authPolicies,
      authToken: token,
    },
  });
};

const setAuthToken = token => ({
  type: SET_AUTH_TOKEN,
  token,
});

// New django redux store 
const setDjangoAuthData = ({ access, roles, userInfo }) => ({
  type: SET_DJANGO_AUTH_DATA,
  payload: { access, roles, userInfo },
});

export default {
  loadAuthData,
  setKeycloakInstance,
  logoutUser,
  setAuthToken,
  setDjangoAuthData,
};
